module.exports = __webpack_public_path__ + "static/media/multiple_person_demo.e88311d4.mp4";